import { Button, Spinner } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { create } from 'react-modal-promise';
import { useState } from 'react';

const BootStrapModal = (props) => {
    const [inProgress, setProgress] = useState(false);
    const handleOk = () => {
        if (props.onConfirm) {
            setProgress(true);
            props
                .onConfirm(props.row.original.id, props.row, props.rows)
                .then(() => {
                    props.onResolve(true);
                    setProgress(false);
                    return;
                })
                .catch(() => {
                    props.onResolve(false);
                    setProgress(false);
                });
            return;
        } else {
            props.onResolve(true);
        }
    };

    const handleCancel = () => props.onReject(false);
    return (
        <Modal show={props.isOpen} onHide={handleCancel}>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            {props.body && <Modal.Body>{props.body}</Modal.Body>}
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel} hidden={props.cancelHidden}>
                    {props.cancelText}
                </Button>
                <Button variant="primary" onClick={handleOk} disabled={inProgress}>
                    {inProgress && <Spinner as="span" animation="border" size="sm" aria-hidden="true" />} {props.okText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export const FormModal = create(BootStrapModal);
